(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-article-content]').forEach((content) => {
      const fallbackImage = content.dataset.articleFallbackImage;

      content.querySelectorAll('img').forEach((image) => {
        const rawSource = image.getAttribute('src') || '';
        const extractedUrl = rawSource.match(/https?:\/\/[^"'\\\s>]+/);
        const useFallbackImage = () => {
          if (fallbackImage && image.src !== fallbackImage) {
            image.src = fallbackImage;
            image.alt = image.alt || 'Article image';
          }
        };

        if (rawSource.includes('\\"') && extractedUrl) {
          image.src = extractedUrl[0];
        }

        image.addEventListener('error', useFallbackImage, { once: true });

        if (image.complete && image.naturalWidth === 0) {
          useFallbackImage();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBrandPageContactForms = (root = document) => {
      root.querySelectorAll('.brand-page__form').forEach((form) => {
        if (form.dataset.validationReady === 'true') return;

        const validationMessage = form.querySelector('[data-contact-validation-message]');
        const devMessage = form.querySelector('[data-contact-dev-message]');
        form.dataset.validationReady = 'true';

        form.addEventListener('submit', (event) => {
          if (form.checkValidity()) {
            if (validationMessage) {
              validationMessage.hidden = true;
            }

            const isLocalTheme = ['localhost', '127.0.0.1'].includes(window.location.hostname);
            if (!isLocalTheme) {
              return;
            }

            event.preventDefault();

            const name = form.querySelector('[name="contact[name]"]')?.value.trim() || '';
            const email = form.querySelector('[name="contact[email]"]')?.value.trim() || '';
            const body = form.querySelector('[name="contact[body]"]')?.value.trim() || '';
            const recipient = form.dataset.contactRecipient || 'support@thegacket.com';
            const subject = encodeURIComponent(`Contact request from ${name}`);
            const message = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\n${body}`);

            window.location.href = `mailto:${recipient}?subject=${subject}&body=${message}`;

            if (devMessage) {
              devMessage.textContent = form.dataset.contactSuccess || devMessage.textContent;
              devMessage.hidden = false;
            }

            return;
          }

          event.preventDefault();

          if (validationMessage) {
            validationMessage.hidden = false;
          }

          if (devMessage) {
            devMessage.hidden = true;
          }

          const firstInvalidField = form.querySelector(':invalid');
          if (firstInvalidField) {
            firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstInvalidField.focus({ preventScroll: true });
            firstInvalidField.reportValidity();
          }
        });
      });
    };

    initBrandPageContactForms();

    document.addEventListener('shopify:section:load', (event) => {
      initBrandPageContactForms(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Detailed cart logging
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const viewer = document.getElementById('cart-json-viewer');
      if (viewer) {
        viewer.textContent = JSON.stringify(cart, null, 2);
      }
      
      console.log('%c🛒 CART DATA LOADED', 'color: #000000; font-size: 16px; font-weight: bold;');
      console.log('Total Items:', cart.item_count);
      console.log('Total Price:', '$' + (cart.total_price / 100).toFixed(2));
      console.log('');
      console.log('%c📦 ITEMS BREAKDOWN:', 'color: #000000; font-weight: bold;');
      
      cart.items.forEach((item, idx) => {
        const properties = item.properties || {};
        const measurementValue = properties['Made to Measure'] || 'No';
        const hasMeasurement = measurementValue !== 'No';

        console.log(`Item ${idx + 1}: ${item.title}`);
        console.log(`  Qty: ${item.quantity} | Price: $${(item.price / 100).toFixed(2)}`);
        console.log(`  Made to Measure: ${hasMeasurement ? '✅ ' + measurementValue : '❌ No'}`);
        console.log(`  Key: ${item.key}`);
      });
      
      console.table(cart.items.map((item, i) => {
        const properties = item.properties || {};
        return {
          '#': i + 1,
          Title: item.title,
          Qty: item.quantity,
          Price: '$' + (item.price / 100).toFixed(2),
          'Made to Measure': properties['Made to Measure'] || 'No'
        };
      }));
    })
    .catch(err => console.error('❌ Cart fetch error:', err));

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[id^="CartSection-"]').forEach((section) => {
      const cartCount = section.querySelector('[data-cart-count]');
      const cartSubtotal = section.querySelector('[data-cart-subtotal]');
      const storefrontCurrency = section.dataset.storefrontCurrency || 'USD';
      const cartCurrency = section.dataset.cartCurrency || 'USD';
      const pkrExchangeRate = Number(section.dataset.pkrExchangeRate || 278.61);
      const shopifyPkrMarketRate = Number(section.dataset.shopifyPkrMarketRate || 429.8);

      const moneyFormat = (cents) => {
        const value = Number(cents || 0) / 100;

        if (storefrontCurrency === 'PKR') {
          const pkrValue = cartCurrency === 'PKR'
            ? value * (pkrExchangeRate / shopifyPkrMarketRate)
            : value * pkrExchangeRate;

          return `Rs. ${pkrValue.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }

        return `$${value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      };

      const syncCartTotals = () => {
        let subtotalCents = 0;
        let itemCount = 0;

        section.querySelectorAll('[data-cart-item]').forEach((item) => {
          const input = item.querySelector('[data-qty-input]');
          const total = item.querySelector('[data-line-total]');
          const unitPriceCents = Number(item.dataset.linePriceCents || 0);
          const quantity = Math.max(0, Number(input?.value || 0));
          const lineTotalCents = unitPriceCents * quantity;

          subtotalCents += lineTotalCents;
          itemCount += quantity;

          if (total) {
            total.textContent = moneyFormat(lineTotalCents);
          }
        });

        if (cartSubtotal) {
          cartSubtotal.textContent = moneyFormat(subtotalCents);
        }

        if (cartCount) {
          cartCount.textContent = String(itemCount);
        }
      };

      const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char]));

      const renderLineProperties = (cart) => {
        const itemsByKey = new Map((cart.items || []).map((item) => [item.key, item]));

        section.querySelectorAll('[data-cart-item]').forEach((line) => {
          const target = line.querySelector('[data-line-properties]');
          const toggle = line.querySelector('[data-line-properties-toggle]');
          const cartItem = itemsByKey.get(line.dataset.lineKey);
          const properties = cartItem?.properties || {};

          if (!target || !toggle || !cartItem) return;

          const rows = Object.entries(properties).filter(([name, value]) => {
            return name !== 'Made to Measure' && !name.startsWith('_') && value != null && String(value).trim() !== '';
          });

          if (rows.length === 0) {
            toggle.hidden = true;
            target.hidden = true;
            target.innerHTML = '';
            return;
          }

          target.innerHTML = rows.map(([name, value]) => `
            <p class="cart-editorial__item-property">
              <span>${escapeHtml(name)}:</span>
              <span>${escapeHtml(value).replace(/\n/g, '<br>')}</span>
            </p>
          `).join('');

          toggle.hidden = false;
          target.hidden = toggle.getAttribute('aria-expanded') !== 'true';
        });
      };

      const syncCartState = (cart) => {
        const itemsByKey = new Map((cart.items || []).map((cartItem) => [cartItem.key, cartItem]));

        section.querySelectorAll('[data-cart-item]').forEach((line) => {
          const cartItem = itemsByKey.get(line.dataset.lineKey);
          const input = line.querySelector('[data-qty-input]');

          if (cartItem && input) {
            input.value = cartItem.quantity;
          }
        });

        renderLineProperties(cart);
        syncCartTotals();
      };

      const updateCartLine = (line, quantity) => {
        const input = line.querySelector('[data-qty-input]');
        const controls = line.querySelectorAll('[data-qty-minus], [data-qty-plus], [data-qty-input]');
        const nextQuantity = Math.max(0, Number(quantity || 0));

        if (!input || input.dataset.pendingQuantity === String(nextQuantity)) return;

        input.dataset.pendingQuantity = String(nextQuantity);
        input.value = nextQuantity;
        controls.forEach((control) => { control.disabled = true; });
        syncCartTotals();

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: line.dataset.lineKey,
            quantity: nextQuantity,
          }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('Cart update failed.');
            return response.json();
          })
          .then((cart) => {
            if (nextQuantity === 0) {
              line.remove();
            }

            syncCartState(cart);
          })
          .catch(() => {
            window.location.reload();
          })
          .finally(() => {
            delete input.dataset.pendingQuantity;
            controls.forEach((control) => { control.disabled = false; });
          });
      };

      section.querySelectorAll('[data-cart-item]').forEach((item) => {
        const input = item.querySelector('[data-qty-input]');
        const minus = item.querySelector('[data-qty-minus]');
        const plus = item.querySelector('[data-qty-plus]');
        const detailsToggle = item.querySelector('[data-line-properties-toggle]');
        const details = item.querySelector('[data-line-properties]');

        if (!input || !minus || !plus) return;

        minus.addEventListener('click', () => {
          const nextValue = Math.max(0, Number(input.value || 0) - 1);
          updateCartLine(item, nextValue);
        });

        plus.addEventListener('click', () => {
          const nextValue = Math.max(0, Number(input.value || 0) + 1);
          updateCartLine(item, nextValue);
        });

        input.addEventListener('change', () => {
          updateCartLine(item, input.value);
        });

        if (detailsToggle && details) {
          detailsToggle.addEventListener('click', () => {
            const isOpen = detailsToggle.getAttribute('aria-expanded') === 'true';
            detailsToggle.setAttribute('aria-expanded', String(!isOpen));
            detailsToggle.textContent = isOpen ? 'View details' : 'Hide details';
            details.hidden = isOpen;
          });
        }
      });

      fetch('/cart.js')
        .then((response) => response.json())
        .then(renderLineProperties)
        .catch(() => {});

      syncCartTotals();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.atelierStoryToggleReady) {
      window.atelierStoryToggleReady = true;

      document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-story-toggle]');
        if (!toggle) return;

        const dropdown = toggle.closest('[data-story-dropdown]');
        const more = dropdown ? dropdown.querySelector('[data-story-more]') : null;
        const label = dropdown ? dropdown.querySelector('.atelier-collection__story-toggle-label, .page-men-collection__story-toggle-label') : null;
        if (!dropdown || !more || !label) return;

        event.preventDefault();

        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const collapsedLabel = toggle.dataset.collapsedLabel || 'Read more';
        const expandedLabel = toggle.dataset.expandedLabel || 'Read less';

        toggle.setAttribute('aria-expanded', String(!isExpanded));
        more.hidden = isExpanded;
        label.textContent = isExpanded ? collapsedLabel : expandedLabel;
      });
    }

    const initCollectionSection = (root) => {
      if (!root || root.dataset.collectionFiltersReady === 'true') return;

      const favoriteButtons = Array.from(root.querySelectorAll('[data-favorite-button]'));
      const filterInputs = Array.from(root.querySelectorAll('.atelier-collection__filter-input'));
      const priceRange = root.querySelector('.atelier-collection__price-range');
      const priceMinInput = root.querySelector('[data-price-range-min]');
      const priceMaxInput = root.querySelector('[data-price-range-max-input]');
      const priceProgress = root.querySelector('.atelier-collection__price-progress');
      const priceLabelMin = root.querySelector('[data-price-label-min]');
      const priceLabelMax = root.querySelector('[data-price-label-max]');
      const priceTooltipMin = root.querySelector('[data-price-tooltip-min]');
      const priceTooltipMax = root.querySelector('[data-price-tooltip-max]');
      const sectionToggles = Array.from(root.querySelectorAll('.atelier-collection__section-toggle'));
      const filtersForm = root.querySelector('.atelier-collection__filters-form');
      const siblingToneInputs = Array.from(root.querySelectorAll('[data-sibling-tone-input]'));
      const collectionMain = root.querySelector('.atelier-collection__main');
      const collectionGrid = root.querySelector('.atelier-collection__grid');
      const collectionPagination = root.querySelector('.atelier-collection__pagination');
      let productCards = Array.from(root.querySelectorAll('[data-product-tones]'));
      const siblingToneEmpty = root.querySelector('[data-sibling-tone-empty]');
      const productsPerPage = Number(collectionMain?.dataset.productsPerPage || 24);
      const originalPaginationHTML = collectionPagination ? collectionPagination.innerHTML : '';
      let currentSiblingTonePage = Number(new URLSearchParams(window.location.search).get('page') || 1);
      let siblingToneProductsLoaded = false;
      let siblingToneFetchPromise = null;

      root.dataset.collectionFiltersReady = 'true';

      const normalizePriceValueForFilter = (value) => {
        const numericValue = Number(value || 0);
        return (numericValue / 100).toFixed(2);
      };

      const submitFilters = () => {
        if (!filtersForm) return;

        const formData = new FormData(filtersForm);
        const url = new URL(filtersForm.action || window.location.href, window.location.origin);
        const params = new URLSearchParams();

        formData.forEach((value, key) => {
          if (key === 'page') return;
          if (key === 'sibling_tone') return;
          if (value === '') return;

          if (key === priceMinInput?.name || key === priceMaxInput?.name) {
            params.append(key, normalizePriceValueForFilter(value));
            return;
          }

          params.append(key, value);
        });

        getActiveSiblingTones().forEach((tone) => {
          params.append('sibling_tone', tone);
        });

        url.search = params.toString();
        window.location.assign(url.toString());
      };

      const getSelectedSiblingTones = () => siblingToneInputs
        .filter((input) => input.checked)
        .map((input) => input.value);

      const getActiveSiblingTones = () => {
        const selectedTones = getSelectedSiblingTones();
        if (selectedTones.length) return selectedTones;

        return new URLSearchParams(window.location.search).getAll('sibling_tone');
      };

      const cardMatchesSiblingTone = (card, tone) => {
        const productTones = card.dataset.productTones || '';
        const productTitleHandle = card.dataset.productTitleHandle || '';
        const toneMarker = `|${tone}|`;
        const titleHandleMarker = `-${tone}-`;

        return productTones.includes(toneMarker) || productTitleHandle.includes(titleHandleMarker);
      };

      const syncAvailableSiblingTones = () => {
        if (!siblingToneInputs.length || !productCards.length) return false;

        siblingToneInputs.forEach((input) => {
          const label = input.closest('.atelier-collection__tone-wrap');

          input.disabled = false;
          if (label) {
            label.hidden = false;
            label.classList.remove('is-unavailable');
          }
        });

        return false;
      };

      const resetFetchedSiblingToneCards = () => {
        if (!collectionGrid) return;

        collectionGrid.querySelectorAll('[data-sibling-tone-fetched="true"]').forEach((card) => {
          card.remove();
        });

        productCards = Array.from(root.querySelectorAll('[data-product-tones]'));
      };

      const getProductCardKey = (card) => {
        const favoriteButton = card.querySelector('[data-product-id]');
        if (favoriteButton) {
          return favoriteButton.dataset.productId || '';
        }

        const productLink = card.querySelector('.atelier-collection__card-media-link, .atelier-collection__card-title a');
        if (productLink) {
          return productLink.getAttribute('href') || '';
        }

        return card.dataset.productTitleHandle || '';
      };

      const getSiblingToneFetchPageUrls = () => {
        const pageNumbers = new Set([1]);
        const paginationLinks = Array.from(root.querySelectorAll('.atelier-collection__pagination a[href]'));

        paginationLinks.forEach((link) => {
          const linkUrl = new URL(link.href, window.location.origin);
          const pageNumber = Number(linkUrl.searchParams.get('page') || 1);

          if (Number.isFinite(pageNumber) && pageNumber > 0) {
            pageNumbers.add(pageNumber);
          }
        });

        const maxPage = Math.max(...Array.from(pageNumbers));
        for (let pageNumber = 1; pageNumber <= maxPage; pageNumber += 1) {
          pageNumbers.add(pageNumber);
        }

        return Array.from(pageNumbers)
          .sort((first, second) => first - second)
          .map((pageNumber) => {
            const pageUrl = new URL(window.location.href);
            pageUrl.searchParams.delete('sibling_tone');
            pageUrl.searchParams.set('page', String(pageNumber));
            return pageUrl.toString();
          });
      };

      const mergeSiblingToneCardsFromDocument = (doc) => {
        if (!collectionGrid) return;

        const knownCardKeys = new Set(productCards.map(getProductCardKey).filter(Boolean));
        const fetchedCards = Array.from(doc.querySelectorAll('[data-product-tones]'));

        fetchedCards.forEach((card) => {
          const cardKey = getProductCardKey(card);
          if (!cardKey || knownCardKeys.has(cardKey)) return;

          const importedCard = document.importNode(card, true);
          importedCard.dataset.siblingToneFetched = 'true';
          collectionGrid.appendChild(importedCard);
          productCards.push(importedCard);
          knownCardKeys.add(cardKey);
        });
      };

      const loadAllSiblingToneProducts = () => {
        if (siblingToneProductsLoaded) return Promise.resolve();
        if (siblingToneFetchPromise) return siblingToneFetchPromise;

        const pageUrls = getSiblingToneFetchPageUrls();
        siblingToneFetchPromise = Promise.all(
          pageUrls.map((pageUrl) => fetch(pageUrl, { credentials: 'same-origin' })
            .then((response) => {
              if (!response.ok) return '';
              return response.text();
            })
            .then((html) => {
              if (!html) return;
              const doc = new DOMParser().parseFromString(html, 'text/html');
              mergeSiblingToneCardsFromDocument(doc);
            })
            .catch(() => {}))
        ).then(() => {
          siblingToneProductsLoaded = true;
        });

        return siblingToneFetchPromise;
      };

      const updateSiblingToneUrl = (pageNumber = 1) => {
        const url = new URL(window.location.href);
        url.searchParams.delete('sibling_tone');
        url.searchParams.delete('page');

        getSelectedSiblingTones().forEach((tone) => {
          url.searchParams.append('sibling_tone', tone);
        });

        if (pageNumber > 1) {
          url.searchParams.set('page', String(pageNumber));
        }

        window.history.replaceState({}, '', url.toString());
      };

      const renderSiblingTonePagination = (totalPages, currentPage) => {
        if (!collectionPagination) return;

        if (totalPages <= 1) {
          collectionPagination.hidden = true;
          collectionPagination.innerHTML = originalPaginationHTML;
          return;
        }

        const selectedToneQuery = getSelectedSiblingTones()
          .map((tone) => `sibling_tone=${encodeURIComponent(tone)}`)
          .join('&');
        const pageLinks = Array.from({ length: totalPages }, (_item, index) => {
          const pageNumber = index + 1;
          const pageUrl = new URL(window.location.href);
          pageUrl.searchParams.delete('sibling_tone');
          pageUrl.searchParams.delete('page');

          if (selectedToneQuery) {
            selectedToneQuery.split('&').forEach((part) => {
              const [key, value] = part.split('=');
              pageUrl.searchParams.append(key, decodeURIComponent(value || ''));
            });
          }

          if (pageNumber > 1) {
            pageUrl.searchParams.set('page', String(pageNumber));
          }

          if (pageNumber === currentPage) {
            return `<span class="atelier-collection__pagination-link atelier-collection__pagination-link--page is-active">${String(pageNumber).padStart(2, '0')}</span>`;
          }

          return `<a class="atelier-collection__pagination-link atelier-collection__pagination-link--page" href="${pageUrl.toString()}" data-sibling-tone-page="${pageNumber}">${String(pageNumber).padStart(2, '0')}</a>`;
        }).join('');

        const previousPage = currentPage - 1;
        const nextPage = currentPage + 1;
        const previousControl = previousPage >= 1
          ? `<a class="atelier-collection__pagination-link atelier-collection__pagination-link--edge" href="#" data-sibling-tone-page="${previousPage}"><span aria-hidden="true">&larr;</span><span>Previous</span></a>`
          : '<span class="atelier-collection__pagination-link atelier-collection__pagination-link--edge is-disabled"><span aria-hidden="true">&larr;</span><span>Previous</span></span>';
        const nextControl = nextPage <= totalPages
          ? `<a class="atelier-collection__pagination-link atelier-collection__pagination-link--edge" href="#" data-sibling-tone-page="${nextPage}"><span>Next</span><span aria-hidden="true">&rarr;</span></a>`
          : '<span class="atelier-collection__pagination-link atelier-collection__pagination-link--edge is-disabled"><span>Next</span><span aria-hidden="true">&rarr;</span></span>';

        collectionPagination.innerHTML = `
          <div class="atelier-collection__pagination-line" aria-hidden="true"></div>
          <nav class="atelier-collection__pagination-nav" aria-label="Pagination">
            ${previousControl}
            <div class="atelier-collection__pagination-pages">${pageLinks}</div>
            ${nextControl}
          </nav>
        `;
        collectionPagination.hidden = false;
      };

      const filterSiblingToneCards = () => {
        if (!siblingToneInputs.length || !productCards.length) return;

        const selectedTones = getSelectedSiblingTones();

        if (!selectedTones.length) {
          productCards.forEach((card) => {
            card.hidden = false;
            card.classList.remove('is-hidden-by-tone');
          });

          if (collectionPagination) {
            collectionPagination.innerHTML = originalPaginationHTML;
            collectionPagination.hidden = false;
          }
          if (siblingToneEmpty) {
            siblingToneEmpty.hidden = true;
          }
          return;
        }

        const matchingCards = productCards.filter((card) => selectedTones.some((tone) => cardMatchesSiblingTone(card, tone)));
        const totalPages = Math.ceil(matchingCards.length / productsPerPage);
        const safeTotalPages = Math.max(totalPages, 1);
        currentSiblingTonePage = Math.min(Math.max(currentSiblingTonePage, 1), safeTotalPages);
        const startIndex = (currentSiblingTonePage - 1) * productsPerPage;
        const endIndex = startIndex + productsPerPage;

        productCards.forEach((card) => {
          const matchingIndex = matchingCards.indexOf(card);
          const shouldShow = matchingIndex >= startIndex && matchingIndex < endIndex;
          card.hidden = !shouldShow;
          card.classList.toggle('is-hidden-by-tone', !shouldShow);
        });

        if (siblingToneEmpty) {
          siblingToneEmpty.hidden = matchingCards.length > 0;
        }

        renderSiblingTonePagination(totalPages, currentSiblingTonePage);
        updateSiblingToneUrl(currentSiblingTonePage);
      };

      const applySiblingToneFilter = () => {
        const selectedTones = getSelectedSiblingTones();

        if (!selectedTones.length) {
          resetFetchedSiblingToneCards();
          siblingToneProductsLoaded = false;
          siblingToneFetchPromise = null;
          if (collectionPagination) {
            collectionPagination.hidden = false;
          }
          filterSiblingToneCards();
          return;
        }

        if (collectionPagination) {
          collectionPagination.hidden = true;
        }
        loadAllSiblingToneProducts().then(filterSiblingToneCards);
      };

      if (collectionPagination) {
        collectionPagination.addEventListener('click', (event) => {
          const pageLink = event.target.closest('[data-sibling-tone-page]');
          if (!pageLink || !getSelectedSiblingTones().length) return;

          event.preventDefault();
          currentSiblingTonePage = Number(pageLink.dataset.siblingTonePage || 1);
          filterSiblingToneCards();
          collectionMain?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      const syncSiblingToneParams = (updateHistory = true) => {
        if (!siblingToneInputs.length) {
          return { url: window.location.href, changed: false };
        }

        const url = new URL(window.location.href);
        url.searchParams.delete('sibling_tone');
        url.searchParams.delete('page');

        getSelectedSiblingTones().forEach((tone) => {
          url.searchParams.append('sibling_tone', tone);
        });

        const nextUrl = url.toString();
        const changed = nextUrl !== window.location.href;
        if (updateHistory) {
          window.history.replaceState({}, '', nextUrl);
        }
        return { url: nextUrl, changed };
      };

      if (siblingToneInputs.length) {
        const selectedToneParams = new URLSearchParams(window.location.search).getAll('sibling_tone');
        const selectedToneParam = selectedToneParams[selectedToneParams.length - 1] || '';

        siblingToneInputs.forEach((input) => {
          input.checked = selectedToneParams.includes(input.value) || input.value === selectedToneParam;
        });

        const unavailableToneRemoved = syncAvailableSiblingTones();

        if (selectedToneParams.length > 1 || unavailableToneRemoved) {
          syncSiblingToneParams();
        }

        applySiblingToneFilter();
      }

      const storefrontCurrency = root.dataset.storefrontCurrency || 'USD';
      const cartCurrency = root.dataset.cartCurrency || 'USD';
      const pkrExchangeRate = Number(root.dataset.pkrExchangeRate || 278.61);
      const shopifyPkrMarketRate = Number(root.dataset.shopifyPkrMarketRate || 429.8);

      const formatMoneyValue = (value) => {
        const numericValue = Number(value || 0);
        const priceValue = numericValue / 100;

        if (storefrontCurrency === 'PKR') {
          const pkrValue = cartCurrency === 'PKR'
            ? priceValue * (pkrExchangeRate / shopifyPkrMarketRate)
            : priceValue * pkrExchangeRate;

          return `Rs. ${pkrValue.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }

        return `$${priceValue.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      };

      const updateTooltipPosition = (tooltip, value, rangeMax) => {
        if (!tooltip) return;
        const ratio = rangeMax > 0 ? value / rangeMax : 0;
        tooltip.style.left = `${ratio * 100}%`;
      };

      const updatePriceProgress = () => {
        if (!priceMinInput || !priceMaxInput || !priceProgress) return;

        const rangeMax = Number(priceMaxInput.dataset.priceRangeMax || priceMaxInput.max || 0);
        let minValue = Number(priceMinInput.value || 0);
        let maxValue = Number(priceMaxInput.value || rangeMax);

        if (minValue > maxValue) {
          if (document.activeElement === priceMinInput) {
            maxValue = minValue;
            priceMaxInput.value = String(maxValue);
          } else {
            minValue = maxValue;
            priceMinInput.value = String(minValue);
          }
        }

        const minRatio = rangeMax > 0 ? Math.min(100, Math.max(0, (minValue / rangeMax) * 100)) : 0;
        const maxRatio = rangeMax > 0 ? Math.min(100, Math.max(0, (maxValue / rangeMax) * 100)) : 100;

        priceProgress.style.left = `${minRatio}%`;
        priceProgress.style.right = `${100 - maxRatio}%`;

        if (priceLabelMin) {
          priceLabelMin.textContent = formatMoneyValue(minValue);
        }

        if (priceLabelMax) {
          priceLabelMax.textContent = formatMoneyValue(maxValue);
        }

        if (priceTooltipMin) {
          priceTooltipMin.textContent = formatMoneyValue(minValue);
          updateTooltipPosition(priceTooltipMin, minValue, rangeMax);
        }

        if (priceTooltipMax) {
          priceTooltipMax.textContent = formatMoneyValue(maxValue);
          updateTooltipPosition(priceTooltipMax, maxValue, rangeMax);
        }
      };

      const normalizeCurrentPriceParams = () => {
        if (!priceMinInput || !priceMaxInput) return false;

        const url = new URL(window.location.href);
        const rangeMax = Number(priceMaxInput.dataset.priceRangeMax || priceMaxInput.max || 0);
        const rangeMaxDollars = rangeMax / 100;
        let changed = false;

        [priceMinInput.name, priceMaxInput.name].forEach((paramName) => {
          const rawValue = url.searchParams.get(paramName);
          if (!rawValue) return;

          const numericValue = Number(rawValue);
          if (!Number.isFinite(numericValue)) return;

          if (numericValue > rangeMaxDollars && numericValue <= rangeMax) {
            url.searchParams.set(paramName, normalizePriceValueForFilter(numericValue));
            changed = true;
          }
        });

        if (changed) {
          window.location.replace(url.toString());
        }

        return changed;
      };

      const syncPriceInputsFromParams = () => {
        if (!priceMinInput || !priceMaxInput) return;

        const params = new URLSearchParams(window.location.search);
        const rangeMax = Number(priceMaxInput.dataset.priceRangeMax || priceMaxInput.max || 0);
        const rangeMaxDollars = rangeMax / 100;

        [
          { input: priceMinInput, fallback: 0 },
          { input: priceMaxInput, fallback: rangeMax },
        ].forEach(({ input, fallback }) => {
          const rawValue = params.get(input.name);
          if (!rawValue) {
            input.value = String(fallback);
            return;
          }

          const numericValue = Number(rawValue);
          if (!Number.isFinite(numericValue)) return;

          if (numericValue <= rangeMaxDollars) {
            input.value = String(Math.round(numericValue * 100));
          }
        });
      };

      const bindPriceTooltip = (input, tooltip) => {
        if (!input || !tooltip || !priceRange) return;

        const showTooltip = () => {
          priceRange.classList.add('is-hovering');
          tooltip.classList.add('is-visible');
        };

        const hideTooltip = () => {
          tooltip.classList.remove('is-visible');
          if (!priceRange.querySelector('.atelier-collection__price-tooltip.is-visible')) {
            priceRange.classList.remove('is-hovering');
          }
        };

        input.addEventListener('mouseenter', showTooltip);
        input.addEventListener('mouseleave', hideTooltip);
        input.addEventListener('focus', showTooltip);
        input.addEventListener('blur', hideTooltip);
        input.addEventListener('input', showTooltip);
      };

      if (priceMinInput && priceMaxInput) {
        if (normalizeCurrentPriceParams()) return;

        syncPriceInputsFromParams();
        updatePriceProgress();
        priceMinInput.addEventListener('input', updatePriceProgress);
        priceMaxInput.addEventListener('input', updatePriceProgress);
        priceMinInput.addEventListener('change', submitFilters);
        priceMaxInput.addEventListener('change', submitFilters);
        bindPriceTooltip(priceMinInput, priceTooltipMin);
        bindPriceTooltip(priceMaxInput, priceTooltipMax);
      }

      filterInputs.forEach((input) => {
        const label = input.closest('.atelier-collection__filter-link, .atelier-collection__tone-wrap');
        if (!label) return;

        const syncInputState = () => {
          if (input.type === 'radio') {
            const radioGroup = root.querySelectorAll(`input[type="radio"][name="${input.name}"]`);
            radioGroup.forEach((radio) => {
              const radioLabel = radio.closest('.atelier-collection__filter-link, .atelier-collection__tone-wrap');
              const tone = radioLabel ? radioLabel.querySelector('.atelier-collection__tone') : null;
              if (!radioLabel) return;

              radioLabel.classList.toggle('is-active', radio.checked);
              if (tone) {
                tone.classList.toggle('is-active', radio.checked);
              }
            });
            return;
          }

          const tone = label.querySelector('.atelier-collection__tone');
          label.classList.toggle('is-active', input.checked);
          if (tone) {
            tone.classList.toggle('is-active', input.checked);
          }
        };

        input.addEventListener('change', syncInputState);
        if (input.hasAttribute('data-sibling-tone-input')) {
          input.addEventListener('change', () => {
            if (input.checked) {
              siblingToneInputs.forEach((toneInput) => {
                if (toneInput !== input) {
                  toneInput.checked = false;
                  const toneLabel = toneInput.closest('.atelier-collection__tone-wrap');
                  const tone = toneLabel ? toneLabel.querySelector('.atelier-collection__tone') : null;
                  if (toneLabel) {
                    toneLabel.classList.remove('is-active');
                  }
                  if (tone) {
                    tone.classList.remove('is-active');
                  }
                }
              });
            }

            currentSiblingTonePage = 1;
            syncSiblingToneParams();
            applySiblingToneFilter();
          });
        } else {
          input.addEventListener('change', submitFilters);
        }
        syncInputState();
      });

      const animateAccordion = (toggle, content, shouldOpen) => {
        content.hidden = false;
        content.classList.remove('is-collapsed');

        if (shouldOpen) {
          const contentHeight = content.scrollHeight;
          content.style.maxHeight = '0px';
          content.style.opacity = '0';

          requestAnimationFrame(() => {
            content.style.maxHeight = `${contentHeight}px`;
            content.style.opacity = '1';
          });

          window.setTimeout(() => {
            if (toggle.getAttribute('aria-expanded') === 'true') {
              content.style.maxHeight = 'none';
            }
          }, 320);
        } else {
          const contentHeight = content.scrollHeight;
          content.style.maxHeight = `${contentHeight}px`;
          content.style.opacity = '1';

          requestAnimationFrame(() => {
            content.classList.add('is-collapsed');
            content.style.maxHeight = '0px';
            content.style.opacity = '0';
          });
        }
      };

      const shouldCollapseFiltersByDefault = window.matchMedia('(max-width: 749px)').matches;

      sectionToggles.forEach((toggle) => {
        const section = toggle.closest('.atelier-collection__filter-section');
        const content = section ? section.querySelector('[data-accordion-content]') : null;
        if (!section || !content) return;

        toggle.setAttribute('aria-expanded', shouldCollapseFiltersByDefault ? 'false' : 'true');
        content.hidden = false;
        content.classList.toggle('is-collapsed', shouldCollapseFiltersByDefault);
        content.style.maxHeight = shouldCollapseFiltersByDefault ? '0px' : 'none';
        content.style.opacity = shouldCollapseFiltersByDefault ? '0' : '1';

        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          const nextExpanded = !isExpanded;
          toggle.setAttribute('aria-expanded', String(nextExpanded));
          animateAccordion(toggle, content, nextExpanded);
        });
      });

      if (favoriteButtons.length) {
        const storageKey = 'atelierCollectionFavorites';
        let favoriteIds = [];

        try {
          favoriteIds = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        } catch (_error) {
          favoriteIds = [];
        }

        const syncFavorites = () => {
          favoriteButtons.forEach((button) => {
            const productId = button.dataset.productId;
            const isActive = favoriteIds.includes(productId);
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        };

        favoriteButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const productId = button.dataset.productId;
            if (!productId) return;

            if (favoriteIds.includes(productId)) {
              favoriteIds = favoriteIds.filter((id) => id !== productId);
            } else {
              favoriteIds = favoriteIds.concat(productId);
            }

            window.localStorage.setItem(storageKey, JSON.stringify(favoriteIds));
            syncFavorites();
          });
        });

        syncFavorites();
      }

      const storyDropdowns = Array.from(root.querySelectorAll('[data-story-dropdown]'));

      storyDropdowns.forEach((dropdown) => {
        const toggle = dropdown.querySelector('[data-story-toggle]');
        const more = dropdown.querySelector('[data-story-more]');
        const label = dropdown.querySelector('.atelier-collection__story-toggle-label');

        if (!toggle || !more || !label) return;

        toggle.addEventListener('click', (event) => {
          event.stopPropagation();
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          const collapsedLabel = toggle.dataset.collapsedLabel || 'Read more';
          toggle.setAttribute('aria-expanded', String(!isExpanded));
          more.hidden = isExpanded;
          label.textContent = isExpanded ? collapsedLabel : 'Read less';
        });
      });

    };

    const initAllCollectionSections = () => {
      document.querySelectorAll('.shopify-section').forEach((section) => {
        if (section.querySelector('.atelier-collection')) {
          initCollectionSection(section);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCollectionSections);
    } else {
      initAllCollectionSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initCollectionSection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize-jacket"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCustomOrderForms = (root = document) => {
      root.querySelectorAll('[data-custom-order-form]').forEach((form) => {
        if (form.dataset.customOrderReady == 'true') return;

        const status = form.querySelector('[data-custom-order-status]');
        const submit = form.querySelector('[type="submit"]');

        form.dataset.customOrderReady = 'true';

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (!form.reportValidity()) return;

          const variantInput = form.querySelector('[name="id"]');
          if (!variantInput || !variantInput.value) {
            if (status) status.textContent = 'Select the custom order product before submitting.';
            return;
          }

          if (submit) submit.disabled = true;
          if (status) status.textContent = 'Adding your request to cart...';

          const submitFormNormally = () => {
            HTMLFormElement.prototype.submit.call(form);
          };

          try {
            if (window.location.hostname == '127.0.0.1' || window.location.hostname == 'localhost') {
              submitFormNormally();
              return;
            }

            const response = await fetch(`${form.action}.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form),
            });

            if (!response.ok) {
              throw new Error('Cart add request failed.');
            }

            if (status) status.textContent = form.dataset.successMessage;
            window.location.href = form.dataset.cartUrl || '/cart';
          } catch (error) {
            submitFormNormally();
          }
        });
      });
    };

    initCustomOrderForms();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    if (window.gacketFooterNewsletterReady) return;
    window.gacketFooterNewsletterReady = true;

    const isFooterNewsletterForm = (form) => (
      form instanceof HTMLFormElement
      && form.matches('[data-footer-newsletter-form], .gacket-footer__form')
    );

    const saveLocalEmail = (email) => {
      if (!email) return;

      try {
        const storageKey = 'gacketFooterNewsletterEmails';
        const storedEmails = JSON.parse(window.localStorage.getItem(storageKey) || '[]');

        if (!storedEmails.includes(email)) {
          storedEmails.unshift(email);
          window.localStorage.setItem(storageKey, JSON.stringify(storedEmails.slice(0, 20)));
        }
      } catch (_error) {
        /* Local storage is only a dev fallback. */
      }
    };

    const handleFooterNewsletterSubmit = async (form) => {
      if (!isFooterNewsletterForm(form)) return;

      if (form.dataset.newsletterSubmitting === 'true') return;

      const submitButton = form.querySelector('button[type="submit"]');
      const emailInput = form.querySelector('input[name="contact[email]"]');
      const message = form.querySelector('.gacket-footer__form-message');

      if (emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
      }

      if (message) {
        message.hidden = true;
        message.textContent = '';
        message.setAttribute('role', 'status');
      }

      const showSuccess = (text) => {
        saveLocalEmail(emailInput ? emailInput.value.trim() : '');

        if (message) {
          message.textContent = text || 'Thanks for subscribing.';
          message.hidden = false;
          message.setAttribute('role', 'status');
        }

        form.reset();
      };

      try {
        form.dataset.newsletterSubmitting = 'true';

        if (!window.fetch || !window.FormData) {
          showSuccess('Thanks for subscribing.');
          return;
        }

        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          throw new Error('Newsletter request failed');
        }

        showSuccess('Thanks for subscribing.');
      } catch (_error) {
        showSuccess('Thanks. We saved your email for newsletter updates.');
      } finally {
        delete form.dataset.newsletterSubmitting;

        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    };

    window.gacketFooterNewsletterSubmit = (form, event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
      }

      handleFooterNewsletterSubmit(form);

      return false;
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!isFooterNewsletterForm(form)) return;

      window.gacketFooterNewsletterSubmit(form, event);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const initHeaderMenu = (header) => {
      if (!header || header.dataset.menuReady == 'true') return;

      const toggle = header.querySelector('.site-header__menu-toggle');
      const panel = header.querySelector('.site-header__panel');
      const backdrop = header.querySelector('.site-header__backdrop');
      const desktopMedia = window.matchMedia('(min-width: 990px)');

      if (!toggle || !panel || !backdrop) return;

      header.dataset.menuReady = 'true';

      const closeMobileMegaMenus = () => {
        header.querySelectorAll('.site-header__nav-item--has-mega').forEach((item) => {
          const mobileToggle = item.querySelector('.site-header__mobile-dropdown-toggle');
          const megaMenu = item.querySelector('.site-header__mega-menu');

          item.classList.remove('is-mobile-mega-open');

          if (mobileToggle) {
            mobileToggle.setAttribute('aria-expanded', 'false');
          }

          if (megaMenu) {
            megaMenu.setAttribute('aria-hidden', 'true');
          }
        });
      };

      const closeMenu = () => {
        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('site-header-menu-open');
        closeMobileMegaMenus();
      };

      const openMenu = () => {
        header.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('site-header-menu-open');
      };

      const syncMenuState = () => {
        if (desktopMedia.matches) {
          closeMenu();
          return;
        }

        if (!header.classList.contains('is-open')) {
          toggle.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('site-header-menu-open');
        }
      };

      toggle.addEventListener('click', () => {
        if (header.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      header.querySelectorAll('.site-header__mobile-dropdown-toggle').forEach((mobileToggle) => {
        mobileToggle.addEventListener('click', () => {
          if (desktopMedia.matches) return;

          const item = mobileToggle.closest('.site-header__nav-item--has-mega');
          if (!item) return;

          const megaMenu = item.querySelector('.site-header__mega-menu');
          const isOpen = item.classList.contains('is-mobile-mega-open');

          header.querySelectorAll('.site-header__nav-item--has-mega').forEach((otherItem) => {
            if (otherItem == item) return;

            const otherToggle = otherItem.querySelector('.site-header__mobile-dropdown-toggle');
            const otherMegaMenu = otherItem.querySelector('.site-header__mega-menu');

            otherItem.classList.remove('is-mobile-mega-open');

            if (otherToggle) {
              otherToggle.setAttribute('aria-expanded', 'false');
            }

            if (otherMegaMenu) {
              otherMegaMenu.setAttribute('aria-hidden', 'true');
            }
          });

          item.classList.toggle('is-mobile-mega-open', !isOpen);
          mobileToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

          if (megaMenu) {
            megaMenu.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
          }
        });
      });

      panel.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          if (!desktopMedia.matches) {
            closeMenu();
          }
        });
      });

      backdrop.addEventListener('click', closeMenu);

      document.addEventListener('keydown', (event) => {
        if (event.key == 'Escape') {
          closeMenu();
        }
      });

      if (desktopMedia.addEventListener) {
        desktopMedia.addEventListener('change', syncMenuState);
      } else {
        desktopMedia.addListener(syncMenuState);
      }

      syncMenuState();
    };

    const initAllHeaderMenus = (root = document) => {
      root.querySelectorAll('.site-header').forEach(initHeaderMenu);
    };

    if (document.readyState == 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllHeaderMenus(), { once: true });
    } else {
      initAllHeaderMenus();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllHeaderMenus(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroSections = document.querySelectorAll('.hero-section[data-slider-enabled="true"]');

    heroSections.forEach((section) => {
      const slides = Array.from(section.querySelectorAll('.hero-section__slide'));
      const dots = Array.from(section.querySelectorAll('.hero-section__dot'));

      if (slides.length < 2) {
        return;
      }

      const autoplaySeconds = Number(section.dataset.autoplaySeconds || 5);
      const autoplayDelay = Number.isFinite(autoplaySeconds) && autoplaySeconds > 0 ? autoplaySeconds * 1000 : 5000;
      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      let timerId;
      let leavingTimerId;

      if (activeIndex < 0) {
        activeIndex = 0;
      }

      const setActiveSlide = (index) => {
        if (index === activeIndex) {
          return;
        }

        const previousSlide = slides[activeIndex];
        activeIndex = index;
        window.clearTimeout(leavingTimerId);

        if (previousSlide) {
          previousSlide.classList.add('is-leaving');
          leavingTimerId = window.setTimeout(() => {
            previousSlide.classList.remove('is-leaving');
          }, 1000);
        }

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
        });

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const scheduleNextSlide = () => {
        window.clearTimeout(timerId);
        timerId = window.setTimeout(() => {
          const nextIndex = (activeIndex + 1) % slides.length;
          setActiveSlide(nextIndex);
          scheduleNextSlide();
        }, autoplayDelay);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const targetIndex = Number(dot.dataset.slideTarget || 0);
          setActiveSlide(targetIndex);
          scheduleNextSlide();
        });
      });

      setActiveSlide(activeIndex);
      scheduleNextSlide();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-men-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.atelierStoryToggleReady) {
      window.atelierStoryToggleReady = true;

      document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-story-toggle]');
        if (!toggle) return;

        const dropdown = toggle.closest('[data-story-dropdown]');
        const more = dropdown ? dropdown.querySelector('[data-story-more]') : null;
        const label = dropdown ? dropdown.querySelector('.atelier-collection__story-toggle-label, .page-men-collection__story-toggle-label') : null;
        if (!dropdown || !more || !label) return;

        event.preventDefault();

        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const collapsedLabel = toggle.dataset.collapsedLabel || 'Read more';
        const expandedLabel = toggle.dataset.expandedLabel || 'Read less';

        toggle.setAttribute('aria-expanded', String(!isExpanded));
        more.hidden = isExpanded;
        label.textContent = isExpanded ? collapsedLabel : expandedLabel;
      });
    }

    const initPageCollection = (section) => {
      const pagination = section.querySelector('[data-pagination]');
      const grid = section.querySelector('.page-men-collection__grid');
      const pageItems = Array.from(section.querySelectorAll('[data-page-item]'));

      if (!pagination || !pageItems.length || pagination.dataset.paginationReady == 'true') return;

      pagination.dataset.paginationReady = 'true';

      const itemsPerPage = Number(pagination.dataset.itemsPerPage || 12);
      const totalPages = Math.max(1, Math.ceil(pageItems.length / itemsPerPage));
      const prevButton = pagination.querySelector('[data-pagination-prev]');
      const nextButton = pagination.querySelector('[data-pagination-next]');
      const pageButtons = Array.from(pagination.querySelectorAll('[data-page-target]'));
      let currentPage = 0;

      const syncPageUrl = () => {
        const pageNumber = currentPage + 1;
        const url = new URL(window.location.href);

        if (pageNumber > 1) {
          url.searchParams.set('collection_page', String(pageNumber));
        } else {
          url.searchParams.delete('collection_page');
        }

        window.history.replaceState({}, '', url.toString());
      };

      const scrollToGrid = () => {
        if (!grid) return;

        grid.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      };

      const renderPage = (pageIndex, shouldScroll = false) => {
        currentPage = Math.max(0, Math.min(pageIndex, totalPages - 1));
        pagination.dataset.currentPage = String(currentPage);

        pageItems.forEach((item, index) => {
          const start = currentPage * itemsPerPage;
          const end = start + itemsPerPage;
          item.hidden = index < start || index >= end;
        });

        pageButtons.forEach((button, index) => {
          const isActive = index == currentPage;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-current', isActive ? 'page' : 'false');
        });

        if (prevButton) {
          const isDisabled = currentPage == 0;
          prevButton.disabled = isDisabled;
          prevButton.classList.toggle('is-disabled', isDisabled);
        }

        if (nextButton) {
          const isDisabled = currentPage == totalPages - 1;
          nextButton.disabled = isDisabled;
          nextButton.classList.toggle('is-disabled', isDisabled);
        }

        syncPageUrl();

        if (shouldScroll) {
          scrollToGrid();
        }
      };

      pagination.addEventListener('click', (event) => {
        const pageButton = event.target.closest('[data-page-target]');
        const previousButton = event.target.closest('[data-pagination-prev]');
        const followingButton = event.target.closest('[data-pagination-next]');

        if (!pageButton && !previousButton && !followingButton) return;

        event.preventDefault();

        if (pageButton) {
          renderPage(Number(pageButton.dataset.pageTarget || 0), true);
          return;
        }

        if (previousButton) {
          renderPage(currentPage - 1, true);
          return;
        }

        if (followingButton) {
          renderPage(currentPage + 1, true);
        }
      });

      const initialPage = Number(new URLSearchParams(window.location.search).get('collection_page') || 1) - 1;
      renderPage(initialPage);
    };

    const initAllPageCollections = (root = document) => {
      root.querySelectorAll('.page-men-collection').forEach(initPageCollection);
    };

    if (document.readyState == 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllPageCollections(), { once: true });
    } else {
      initAllPageCollections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllPageCollections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const initProductSection = (section) => {
    if (!section || section.dataset.productEditorialInitialized == 'true') return;
    section.dataset.productEditorialInitialized = 'initializing';

    try {
      const variantInput = section.querySelector('[data-variant-id-input]');
      const optionButtons = section.querySelectorAll('[data-option-button]');
      const optionCurrentValues = section.querySelectorAll('[data-option-current-value]');
      const variantsJson = section.querySelector('[data-product-variants]');
      const mainImage = section.querySelector('[data-product-main-image]');
      const galleryTrack = section.querySelector('[data-gallery-track]');
      const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');
      const galleryPrev = section.querySelector('[data-gallery-prev]');
      const galleryNext = section.querySelector('[data-gallery-next]');
      const priceElement = section.querySelector('[data-product-price]');
      const comparePriceElement = section.querySelector('[data-product-compare-price]');
      const submitButton = section.querySelector('[data-submit-button]');
      const submitLabel = section.querySelector('[data-submit-label]');
      const productForm = section.querySelector('.product-editorial__form');
      const relatedTrack = section.querySelector('[data-related-track]');
      const relatedCards = section.querySelectorAll('[data-related-card]');
      const relatedPrev = section.querySelector('[data-related-prev]');
      const relatedNext = section.querySelector('[data-related-next]');
      const discountedTrack = section.querySelector('[data-discounted-track]');
      let discountedCards = Array.from(section.querySelectorAll('[data-discounted-card]'));
      const discountedPrev = section.querySelector('[data-discounted-prev]');
      const discountedNext = section.querySelector('[data-discounted-next]');
      const discountedControls = section.querySelector('.product-editorial__discounted-controls');
      const recentlyViewedSection = section.querySelector('[data-recently-viewed-section]');
      const currentRecentlyViewedNode = section.querySelector('[data-current-recently-viewed-product]');
      const craftsmanshipSection = section.querySelector('[data-craftsmanship-section]');
      const craftsmanshipToggle = section.querySelector('[data-craftsmanship-toggle]');
      const craftsmanshipPanel = section.querySelector('[data-craftsmanship-panel]');
      const measurementSection = section.querySelector('[data-measurement-section]');
      const measurementToggle = section.querySelector('[data-measurement-toggle]');
      const measurementBody = section.querySelector('[data-measurement-body]');
      const measurementCheckbox = section.querySelector('[data-measurement-checkbox]');
      const measurementFalseProperty = section.querySelector('[data-measurement-false-property]');
      const measurementFeeProperty = section.querySelector('[data-measurement-fee-property]');
      const measurementFeeCentsProperty = section.querySelector('[data-measurement-fee-cents-property]');
      const measurementFields = section.querySelectorAll('[data-measurement-field]');
      const measurementFormProperties = section.querySelectorAll('[data-measurement-form-property]');
      const metaAccordions = section.querySelectorAll('[data-meta-accordion]');
      const measurementPriceCents = Number(priceElement?.dataset.measurementPriceCents || 0);
      const measurementFeeVariantId = priceElement?.dataset.measurementFeeVariantId || '';
      const measurementFeeTitle = priceElement?.dataset.measurementFeeTitle || 'Made to Measure';
      let variants = [];
      let activeVariant = null;
      const selectedOptions = {};
      const clickableCards = section.querySelectorAll('[data-card-url]');

      if (variantsJson) {
        try {
          variants = JSON.parse(variantsJson.textContent);
        } catch (error) {
          console.warn('Product section variants JSON could not be parsed.', error);
        }
      }

      optionCurrentValues.forEach((valueNode) => {
        selectedOptions[valueNode.dataset.optionCurrentValue] = valueNode.textContent.trim();
      });

      const getGalleryScrollAmount = () => {
        if (!galleryTrack) return 0;
        return galleryTrack.clientWidth || 0;
      };

      const updateGalleryNav = () => {
        if (!galleryTrack || !galleryPrev || !galleryNext) return;

        const maxScrollLeft = Math.max(galleryTrack.scrollWidth - galleryTrack.clientWidth, 0);
        const currentScrollLeft = Math.round(galleryTrack.scrollLeft);

        galleryPrev.disabled = currentScrollLeft <= 4;
        galleryNext.disabled = currentScrollLeft >= maxScrollLeft - 4;
      };

      const revealThumb = (thumb) => {
        if (!galleryTrack || !thumb) return;

        const trackRect = galleryTrack.getBoundingClientRect();
        const thumbRect = thumb.getBoundingClientRect();

        if (thumbRect.left < trackRect.left || thumbRect.right > trackRect.right) {
          thumb.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
        }
      };

      const syncMainImage = (mediaId) => {
        if (!mainImage || !galleryThumbs.length) return;

        let activeThumb = null;
        galleryThumbs.forEach((thumb) => {
          const isActive = thumb.dataset.mediaId === String(mediaId);
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', String(isActive));
          if (isActive) activeThumb = thumb;
        });

        if (!activeThumb) return;

        mainImage.src = activeThumb.dataset.mediaSrc;
        mainImage.alt = activeThumb.dataset.mediaAlt || mainImage.alt;
        mainImage.dataset.activeMediaId = activeThumb.dataset.mediaId;
        revealThumb(activeThumb);
        updateGalleryNav();
      };

      const syncMainImageFromVariant = (variant) => {
        if (!mainImage || !variant || !variant.featured_image_src) return false;

        mainImage.src = variant.featured_image_src;
        mainImage.alt = variant.featured_image_alt || mainImage.alt;

        let matchedThumb = false;
        galleryThumbs.forEach((thumb) => {
          const isActive = thumb.dataset.mediaSrc === variant.featured_image_src;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', String(isActive));
          if (isActive) {
            matchedThumb = true;
            mainImage.dataset.activeMediaId = thumb.dataset.mediaId;
            revealThumb(thumb);
          }
        });

        if (!matchedThumb) {
          mainImage.dataset.activeMediaId = '';
        }

        return true;
      };

      const findVariantById = (variantId) => {
        if (!variantId || !variants.length) return null;
        return variants.find((variant) => String(variant.id) === String(variantId)) || null;
      };

      const findVariant = () => {
        if (!variants.length) return null;
        
        const variantByOptions = variants.find((variant) => {
          return variant.options.every((optionValue, index) => {
            const selectedValue = selectedOptions[String(index + 1)];

            if (!selectedValue) return true;

            return optionValue === selectedValue;
          });
        }) || null;

        if (variantByOptions) return variantByOptions;

        const currentVariantId = variantInput?.value;
        const variantById = findVariantById(currentVariantId);
        if (variantById) return variantById;

        return null;
      };

      const findClosestAvailableVariant = (preferredPosition, preferredValue) => {
        if (!variants.length) return null;

        return variants.find((variant) => {
          if (!variant.available) return false;

          return variant.options.every((optionValue, index) => {
            const optionPosition = index + 1;

            if (optionPosition === preferredPosition) {
              return optionValue === preferredValue;
            }

            const selectedValue = selectedOptions[String(optionPosition)];
            if (!selectedValue) return true;

            return optionValue === selectedValue;
          });
        }) || variants.find((variant) => {
          return variant.available && variant.options[preferredPosition - 1] === preferredValue;
        }) || variants.find((variant) => variant.available) || null;
      };

      const findImageVariantForSelection = (baseVariant) => {
        if (!variants.length) return null;

        const variantsWithImages = variants.filter((variant) => variant.featured_image_src || variant.featured_media_id);
        if (!variantsWithImages.length) return null;

        let bestVariant = null;
        let bestScore = -1;

        variantsWithImages.forEach((variant) => {
          let score = 0;

          variant.options.forEach((optionValue, index) => {
            const selectedValue = selectedOptions[String(index + 1)];
            if (selectedValue && selectedValue === optionValue) {
              score += 3;
            }
          });

          if (baseVariant) {
            variant.options.forEach((optionValue, index) => {
              if (baseVariant.options[index] === optionValue) {
                score += 2;
              }
            });
          }

          if (score > bestScore) {
            bestScore = score;
            bestVariant = variant;
          }
        });

        return bestVariant || null;
      };

      const syncOptionLabels = () => {
        optionCurrentValues.forEach((valueNode) => {
          const selectedValue = selectedOptions[valueNode.dataset.optionCurrentValue];
          if (selectedValue) {
            valueNode.textContent = selectedValue;
          }
        });
      };

      const syncOptionButtons = () => {
        optionButtons.forEach((button) => {
          const position = Number(button.dataset.optionPosition);
          const buttonValue = button.dataset.optionValue;
          const isSelected = selectedOptions[String(position)] === buttonValue;
          const hasAvailableVariant = variants.length === 0 || variants.some((variant) => {
            if (!variant.available) return false;

            return variant.options.every((optionValue, index) => {
              const optionPosition = index + 1;
              if (optionPosition === position) {
                return optionValue === buttonValue;
              }

              const selectedValue = selectedOptions[String(optionPosition)];
              if (!selectedValue) return true;

              return optionValue === selectedValue;
            });
          });

          if (button.classList.contains('product-editorial__swatch')) {
            button.classList.toggle('is-active', isSelected);
          } else {
            button.classList.toggle('is-selected', isSelected);
          }

          button.classList.toggle('is-unavailable', !hasAvailableVariant);
          button.setAttribute('aria-pressed', String(isSelected));
          button.setAttribute('aria-disabled', String(!hasAvailableVariant));
        });
      };

      const storefrontCurrency = section.dataset.storefrontCurrency || 'USD';
      const cartCurrency = section.dataset.cartCurrency || 'USD';
      const pkrExchangeRate = Number(section.dataset.pkrExchangeRate || 278.61);
      const shopifyPkrMarketRate = Number(section.dataset.shopifyPkrMarketRate || 429.8);

      const formatUsdMoney = (cents) => {
        const value = Number(cents || 0) / 100;

        if (storefrontCurrency === 'PKR') {
          const pkrValue = cartCurrency === 'PKR'
            ? value * (pkrExchangeRate / shopifyPkrMarketRate)
            : value * pkrExchangeRate;

          return `Rs. ${pkrValue.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }

        return `$${value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      };

      const formatMoney = (cents) => {
        return formatUsdMoney(cents);
      };

      const isMeasurementSelected = () => Boolean(measurementCheckbox?.checked);

      const syncMeasurementInputs = () => {
        const isSelected = isMeasurementSelected();
        if (measurementFalseProperty) {
          measurementFalseProperty.disabled = isSelected;
        }
        if (measurementFeeProperty) {
          measurementFeeProperty.disabled = !isSelected;
        }
        if (measurementFeeCentsProperty) {
          measurementFeeCentsProperty.disabled = !isSelected;
        }
        measurementFields.forEach((field) => {
          field.disabled = !isSelected;
          field.required = isSelected;
          if (!isSelected) {
            field.value = '';
          }
        });
        syncMeasurementFormProperties();
      };

      const getEffectiveVariant = (variant) => {
        const hasValidPriceRaw = variant && variant.price_raw != null && Number.isFinite(Number(variant.price_raw));
        if (hasValidPriceRaw) {
          return variant;
        }

        return getDefaultVariant();
      };

      const syncProductPrice = (variant) => {
        if (!priceElement) {
          console.warn('❌ No priceElement found!');
          return;
        }

        const resolvedVariant = getEffectiveVariant(variant);
        if (!resolvedVariant) {
          console.warn('❌ No variant found for price sync!');
          return;
        }

        activeVariant = resolvedVariant;
        if (variantInput) {
          variantInput.value = String(resolvedVariant.id);
        }

        const rawPrice = Number(resolvedVariant.price_raw);
        const hasBasePrice = Number.isFinite(rawPrice) && rawPrice >= 0;

        if (hasBasePrice) {
          priceElement.textContent = formatMoney(rawPrice);
          return;
        }

        priceElement.textContent = resolvedVariant.price || priceElement.textContent || formatMoney(0);
      };

      const addSelectedMeasurementProperties = (formData) => {
        if (!formData || !isMeasurementSelected()) return formData;

        syncMeasurementFormProperties();

        formData.set('properties[Made to Measure]', `Yes (+${formatUsdMoney(measurementPriceCents)})`);
        formData.set('properties[Measurement Fee]', `+${formatUsdMoney(measurementPriceCents)}`);
        formData.set('properties[_Measurement fee cents]', String(measurementPriceCents));

        measurementFields.forEach((field) => {
          if (!field.name) return;
          const fieldValue = field.value.trim();
          if (fieldValue) {
            formData.set(field.name, fieldValue);
          }
        });

        return formData;
      };

      const getSelectedMeasurementProperties = () => {
        const properties = {
          'Made to Measure': `Yes (+${formatUsdMoney(measurementPriceCents)})`,
          'Measurement Fee': `+${formatUsdMoney(measurementPriceCents)}`,
          '_Measurement fee cents': String(measurementPriceCents),
        };

        measurementFields.forEach((field) => {
          const fieldValue = field.value.trim();
          const propertyMatch = field.name.match(/^properties\[(.+)\]$/);
          if (fieldValue && propertyMatch) {
            properties[propertyMatch[1]] = fieldValue;
          }
        });

        return properties;
      };

      const syncMeasurementFormProperties = () => {
        const selectedProperties = isMeasurementSelected() ? getSelectedMeasurementProperties() : {};

        measurementFormProperties.forEach((field) => {
          const propertyName = field.dataset.measurementFormProperty;
          const propertyValue = selectedProperties[propertyName];
          field.disabled = !propertyValue;
          field.value = propertyValue || '';
        });
      };

      const validateSelectedMeasurements = () => {
        if (!isMeasurementSelected()) return true;

        syncMeasurementInputs();

        for (const field of measurementFields) {
          if (!field.value.trim()) {
            field.reportValidity();
            return false;
          }
        }

        return true;
      };

      const syncVariantState = (variant) => {
        if (!variant) return;
        activeVariant = variant;

        variant.options.forEach((optionValue, index) => {
          selectedOptions[String(index + 1)] = optionValue;
        });

        if (variantInput) {
          variantInput.value = variant.id;
        }

        syncOptionLabels();
        syncOptionButtons();
        syncProductPrice(variant);

        if (comparePriceElement) {
          comparePriceElement.textContent = '';
          comparePriceElement.classList.add('is-hidden');
        }

        if (submitButton) {
          submitButton.disabled = !variant.available;
        }

        if (submitLabel && submitButton) {
          submitLabel.textContent = variant.available ? submitButton.dataset.addLabel : submitButton.dataset.soldOutLabel;
        }

        if (variant.featured_media_id) {
          syncMainImage(variant.featured_media_id);
        } else if (!syncMainImageFromVariant(variant)) {
          const imageVariant = findImageVariantForSelection(variant);
          if (imageVariant) {
            if (imageVariant.featured_media_id) {
              syncMainImage(imageVariant.featured_media_id);
            } else {
              syncMainImageFromVariant(imageVariant);
            }
          }
        }
      };

      const getDefaultVariant = () => {
        return activeVariant || findVariantById(variantInput?.value) || findVariant() || variants.find((variant) => variant.available) || variants[0] || null;
      };

      const syncUnavailableState = () => {
        if (variantInput) {
          variantInput.value = '';
        }

        if (submitButton) {
          submitButton.disabled = true;
        }

        if (submitLabel && submitButton) {
          submitLabel.textContent = submitButton.dataset.soldOutLabel;
        }
      };

      const getHeaderCartCountElement = () => {
        let cartCount = document.querySelector('.site-header__cart-count');
        if (cartCount) return cartCount;

        const cartLink = document.querySelector('.site-header__cart');
        if (!cartLink) return null;

        cartCount = document.createElement('span');
        cartCount.className = 'site-header__cart-count';
        cartCount.textContent = '0';
        cartLink.appendChild(cartCount);
        return cartCount;
      };

      const updateHeaderCartCount = async () => {
        try {
          const response = await fetch('/cart.js', {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
            credentials: 'same-origin',
          });

          if (!response.ok) return;

          const cart = await response.json();
          const cartCount = getHeaderCartCountElement();
          if (!cartCount) return;

          cartCount.textContent = String(cart.item_count || 0);
          cartCount.style.display = cart.item_count > 0 ? '' : 'none';
        } catch (error) {
          console.warn('Cart count could not be updated.', error);
        }
      };

      const getCartAddEndpoint = (action) => {
        if (!action) return '/cart/add.js';
        return action.endsWith('.js') ? action : `${action}.js`;
      };

      const addMeasurementFeeVariantToCart = async (targetVariantId) => {
        if (!measurementFeeVariantId) return;

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(measurementFeeVariantId),
                quantity: 1,
                properties: {
                  'Fee for': targetVariantId ? `Variant ${targetVariantId}` : 'Made to Measure',
                  'Measurement service': measurementFeeTitle,
                },
              },
            ],
          }),
          credentials: 'same-origin',
        });

        if (!response.ok) {
          throw new Error(`Measurement fee add failed with status ${response.status}`);
        }

        await response.json();
      };

      const addMeasurementFeeToCart = async () => {
        if (!isMeasurementSelected()) return;
        await addMeasurementFeeVariantToCart(activeVariant?.id);
      };

      const submitMeasuredProductJsonAjax = async (form, buttonLabelNode, buttonNode, defaultLabelText) => {
        if (!form) return;
        if (form.dataset.ajaxSubmitting === 'true') return;
        if (!validateSelectedMeasurements()) return;

        const submitter = buttonNode || form.querySelector('[type="submit"]');
        const submitLabelNode = buttonLabelNode;
        const originalLabel = defaultLabelText || submitLabelNode?.textContent || '';
        form.dataset.ajaxSubmitting = 'true';

        if (submitter) {
          submitter.disabled = true;
        }

        if (submitLabelNode) {
          submitLabelNode.textContent = 'Adding...';
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: Number(variantInput.value),
              quantity: Number(form.querySelector('[name="quantity"]')?.value || 1),
              properties: getSelectedMeasurementProperties(),
            }),
            credentials: 'same-origin',
          });

          if (!response.ok) {
            throw new Error(`Measured product cart add failed with status ${response.status}`);
          }

          await response.json();
          await addMeasurementFeeToCart();
          await updateHeaderCartCount();

          if (submitLabelNode) {
            submitLabelNode.textContent = 'Added';
            window.setTimeout(() => {
              submitLabelNode.textContent = originalLabel;
            }, 1200);
          }
        } catch (error) {
          console.error('Measured product add to cart failed.', error);
          if (submitLabelNode) {
            submitLabelNode.textContent = originalLabel;
          }
        } finally {
          form.dataset.ajaxSubmitting = 'false';
          if (submitter) {
            submitter.disabled = false;
          }
        }
      };

      const submitCartFormAjax = async (form, buttonLabelNode, buttonNode, defaultLabelText, afterAdd, formDataBuilder) => {
        if (!form) return;
        if (form.dataset.ajaxSubmitting === 'true') return;

        const submitter = buttonNode || form.querySelector('[type="submit"]');
        const submitLabelNode = buttonLabelNode;
        const originalLabel = defaultLabelText || submitLabelNode?.textContent || '';
        form.dataset.ajaxSubmitting = 'true';

        if (submitter) {
          submitter.disabled = true;
        }

        if (submitLabelNode) {
          submitLabelNode.textContent = 'Adding...';
        }

        try {
          const formData = typeof formDataBuilder === 'function'
            ? formDataBuilder(new FormData(form))
            : new FormData(form);

          const response = await fetch(getCartAddEndpoint(form.action), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
            body: formData,
            credentials: 'same-origin',
          });

          if (!response.ok) {
            throw new Error(`Cart add failed with status ${response.status}`);
          }

          await response.json();

          if (typeof afterAdd === 'function') {
            await afterAdd();
          }

          await updateHeaderCartCount();

          if (submitLabelNode) {
            submitLabelNode.textContent = 'Added';
            window.setTimeout(() => {
              submitLabelNode.textContent = originalLabel;
            }, 1200);
          }
        } catch (error) {
          console.error('Add to cart failed.', error);
          if (submitLabelNode) {
            submitLabelNode.textContent = originalLabel;
          }
        } finally {
          form.dataset.ajaxSubmitting = 'false';
          if (submitter) {
            submitter.disabled = false;
          }
        }
      };

      section.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action || !form.action.includes('/cart/add')) return;

        event.preventDefault();
        event.stopPropagation();

        if (form.classList.contains('product-editorial__form')) {
          if (!variantInput || !variantInput.value) return;

          if (isMeasurementSelected()) {
            await submitMeasuredProductJsonAjax(
              form,
              submitLabel,
              submitButton,
              submitButton?.dataset.addLabel || submitLabel?.textContent || 'Add To Bag'
            );
            return;
          }

          await submitCartFormAjax(
            form,
            submitLabel,
            submitButton,
            submitButton?.dataset.addLabel || submitLabel?.textContent || 'Add To Bag',
            addMeasurementFeeToCart,
            addSelectedMeasurementProperties
          );
          return;
        }

        if (form.hasAttribute('data-discounted-variant-card')) {
          const cardVariantInput = form.querySelector('[data-discounted-variant-id]');
          const cardSubmit = form.querySelector('[data-discounted-submit]');
          const cardSubmitLabel = cardSubmit?.querySelector('span:last-child');
          const cardMeasurementSection = form.querySelector('[data-discounted-measurement-section]');

          if (!cardVariantInput || !cardVariantInput.value) return;

          await submitCartFormAjax(
            form,
            cardSubmitLabel,
            cardSubmit,
            cardSubmitLabel?.textContent || 'Add To Cart',
            async () => {
              if (cardMeasurementSection?.classList.contains('is-open')) {
                await addMeasurementFeeVariantToCart(cardVariantInput.value);
              }
            }
          );
        }
      }, true);

      const isInteractiveTarget = (target) => {
        if (!target || !target.closest) return false;
        return Boolean(target.closest('a, button, input, select, textarea, label, summary'));
      };

      clickableCards.forEach((card) => {
        const cardUrl = card.dataset.cardUrl;
        if (!cardUrl) return;

        card.addEventListener('click', (event) => {
          if (isInteractiveTarget(event.target)) return;
          window.location.href = cardUrl;
        });

        card.addEventListener('keydown', (event) => {
          if (event.key != 'Enter' && event.key != ' ') return;
          if (isInteractiveTarget(event.target)) return;

          event.preventDefault();
          window.location.href = cardUrl;
        });
      });

      galleryThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          syncMainImage(thumb.dataset.mediaId);
        });
      });

      if (galleryTrack) {
        galleryTrack.addEventListener('scroll', updateGalleryNav, { passive: true });
      }

      if (galleryPrev) {
        galleryPrev.addEventListener('click', () => {
          galleryTrack?.scrollBy({
            left: -getGalleryScrollAmount(),
            behavior: 'smooth',
          });
        });
      }

      if (galleryNext) {
        galleryNext.addEventListener('click', () => {
          galleryTrack?.scrollBy({
            left: getGalleryScrollAmount(),
            behavior: 'smooth',
          });
        });
      }

      window.addEventListener('resize', updateGalleryNav);

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const optionPosition = Number(button.dataset.optionPosition);
          const optionValue = button.dataset.optionValue;
          selectedOptions[button.dataset.optionPosition] = optionValue;

          const variant = findVariant();

          syncOptionLabels();
          syncOptionButtons();

          if (variant) {
            syncVariantState(variant);
          } else {
            syncUnavailableState();
          }
        });
      });

      if (variantInput) {
        variantInput.addEventListener('change', () => {
          const variant = findVariantById(variantInput.value) || findVariant();
          if (variant) {
            syncVariantState(variant);
          }
        });
      }

      if (measurementCheckbox) {
        measurementCheckbox.addEventListener('change', () => {
          const isChecked = measurementCheckbox.checked;
          
          if (priceElement) {
            priceElement.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
            priceElement.style.transition = 'all 0.3s ease';
            setTimeout(() => {
              priceElement.style.backgroundColor = 'transparent';
            }, 300);
          }
          
          if (measurementSection) {
            measurementSection.style.boxShadow = 'inset 0 0 10px rgba(0, 0, 0, 0.15)';
            setTimeout(() => {
              measurementSection.style.boxShadow = 'none';
              measurementSection.style.transition = 'box-shadow 0.3s ease';
            }, 100);
          }
          
          syncMeasurementInputs();
          syncProductPrice(getDefaultVariant());
        });
      }

      measurementFields.forEach((field) => {
        field.addEventListener('input', syncMeasurementFormProperties);
      });

      syncOptionLabels();
      syncOptionButtons();
      syncVariantState(getDefaultVariant());
      syncMeasurementInputs();
      syncProductPrice(getDefaultVariant());
      updateGalleryNav();

      const recentlyViewedStorageKey = 'gacketRecentlyViewedProducts';
      const recentlyViewedCustomizeLabel = recentlyViewedSection?.dataset.recentlyViewedCustomizeLabel || 'Customize Your Size';
      const recentlyViewedCustomizeText = recentlyViewedSection?.dataset.recentlyViewedCustomizeText || 'Made to Measure';
      const recentlyViewedCustomizePrice = recentlyViewedSection?.dataset.recentlyViewedCustomizePrice || 'for $14,000.00';
      const recentlyViewedSizeOptionName = String(recentlyViewedSection?.dataset.recentlyViewedSizeOptionName || 'Size').toLowerCase();
      const recentlyViewedMeasurementTitleKey = String(recentlyViewedSection?.dataset.recentlyViewedMeasurementTitleKey || 'made-to-measure').toLowerCase();
      const recentlyViewedMeasurementLeftItems = String(recentlyViewedSection?.dataset.recentlyViewedMeasurementLeft || '')
        .split(/\r?\n/)
        .map((item) => item.trim())
        .filter(Boolean);
      const recentlyViewedMeasurementRightItems = String(recentlyViewedSection?.dataset.recentlyViewedMeasurementRight || '')
        .split(/\r?\n/)
        .map((item) => item.trim())
        .filter(Boolean);
      const recentlyViewedMeasurementPlaceholder = recentlyViewedSection?.dataset.recentlyViewedMeasurementPlaceholder || 'in/cm';
      const escapeHtml = (value) => String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
      const normalizeRecentlyViewedValue = (value) => String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      const shouldShowRecentlyViewedMeasurement = (recentProduct) => {
        if (recentProduct && typeof recentProduct.showMeasurements === 'boolean') {
          return recentProduct.showMeasurements;
        }

        const productType = String(recentProduct?.type || '').toLowerCase();
        const title = String(recentProduct?.title || '').toLowerCase();
        const handle = String(recentProduct?.handle || '').toLowerCase();

        return productType.includes('jacket')
          || productType.includes('coat')
          || title.includes('jacket')
          || title.includes('coat')
          || handle.includes('jacket')
          || handle.includes('coat');
      };
      const enrichRecentlyViewedProduct = async (recentProduct) => {
        if (!recentProduct?.handle || !recentProduct?.url) return recentProduct;

        const hasRichVariantData = Array.isArray(recentProduct.variants)
          && recentProduct.variants.length > 0
          && Array.isArray(recentProduct.sizes)
          && recentProduct.sizes.length > 0;

        if (hasRichVariantData) return recentProduct;

        try {
          const response = await fetch(`${recentProduct.url}.js`);
          if (!response.ok) return recentProduct;

          const productData = await response.json();
          const optionNames = Array.isArray(productData?.options) ? productData.options : [];
          const sizeOptionIndex = optionNames.findIndex((optionName) => String(optionName || '').toLowerCase() === recentlyViewedSizeOptionName);
          const sizeOptionPosition = sizeOptionIndex + 1;
          const productVariants = Array.isArray(productData?.variants) ? productData.variants : [];
          const sizes = sizeOptionPosition > 0
            ? [...new Set(productVariants.map((variant) => String(variant?.[`option${sizeOptionPosition}`] || '')).filter(Boolean))]
            : [];
          const firstAvailableVariant = productVariants.find((variant) => variant.available) || productVariants[0] || null;

          return {
            ...recentProduct,
            title: recentProduct.title || productData.title,
            handle: recentProduct.handle || productData.handle,
            type: recentProduct.type || productData.type,
            url: recentProduct.url || productData.url,
            available: recentProduct.available ?? Boolean(firstAvailableVariant?.available),
            price: recentProduct.price || (firstAvailableVariant ? formatMoney(firstAvailableVariant.price) : ''),
            priceRaw: recentProduct.priceRaw || firstAvailableVariant?.price || 0,
            showMeasurements: shouldShowRecentlyViewedMeasurement({
              type: recentProduct.type || productData.type,
              title: recentProduct.title || productData.title,
              handle: recentProduct.handle || productData.handle,
            }),
            hasMadeToMeasureSizeOption: sizes.some((sizeValue) => {
              const normalizedValue = normalizeRecentlyViewedValue(sizeValue);
              return normalizedValue === recentlyViewedMeasurementTitleKey || normalizedValue === 'made-to-measure';
            }),
            sizeLabel: recentProduct.sizeLabel || 'Select Size',
            selectedSize: recentProduct.selectedSize || (sizeOptionPosition > 0 ? firstAvailableVariant?.[`option${sizeOptionPosition}`] || '' : ''),
            sizeOptionPosition: sizeOptionPosition > 0 ? sizeOptionPosition : 0,
            sizes,
            variants: productVariants.map((variant) => ({
              id: variant.id,
              available: variant.available,
              price: formatMoney(variant.price),
              priceRaw: variant.price,
              options: optionNames.map((_optionName, optionIndex) => variant[`option${optionIndex + 1}`] || ''),
            })),
          };
        } catch (_error) {
          return recentProduct;
        }
      };
      const getRecentlyViewedSelectedVariant = (recentProduct) => {
        const productVariants = Array.isArray(recentProduct?.variants) ? recentProduct.variants : [];
        if (!productVariants.length) return null;

        const sizePosition = Number(recentProduct?.sizeOptionPosition || 0);
        const selectedSize = String(recentProduct?.selectedSize || '');

        if (sizePosition > 0 && selectedSize) {
          const variantBySize = productVariants.find((variant) => String(variant?.options?.[sizePosition - 1] || '') === selectedSize);
          if (variantBySize) return variantBySize;
        }

        return productVariants.find((variant) => variant.available) || productVariants[0] || null;
      };
      const renderRecentlyViewedSizes = (recentProduct) => {
        const productSizes = Array.isArray(recentProduct?.sizes) ? recentProduct.sizes.filter(Boolean) : [];
        const sizePosition = Number(recentProduct?.sizeOptionPosition || 0);
        const selectedVariant = getRecentlyViewedSelectedVariant(recentProduct);
        const selectedSize = String(recentProduct?.selectedSize || selectedVariant?.options?.[sizePosition - 1] || productSizes[0] || '');

        if (!productSizes.length || !sizePosition) return '';

        return `
          <div class="product-editorial__discounted-meta">
            <span class="product-editorial__discounted-label">${escapeHtml(recentProduct.sizeLabel || 'Select Size')}</span>
            <span class="product-editorial__discounted-value" data-recent-size-current>${escapeHtml(selectedSize)}</span>
          </div>
          <div class="product-editorial__discounted-sizes" data-recent-sizes>
            ${productSizes.map((sizeValue) => `
              <button
                type="button"
                class="product-editorial__discounted-size${selectedSize === sizeValue ? ' is-active' : ''}"
                data-recent-size-button
                data-size-value="${escapeHtml(sizeValue)}"
                aria-pressed="${selectedSize === sizeValue ? 'true' : 'false'}"
              >
                ${escapeHtml(sizeValue)}
              </button>
            `).join('')}
          </div>
        `;
      };
      const renderRecentlyViewedCustomize = (recentProduct) => {
        if (!shouldShowRecentlyViewedMeasurement(recentProduct)) return '';
        if (recentProduct?.hasMadeToMeasureSizeOption) return '';

        const renderMeasurementFields = (fieldItems) => {
          return fieldItems.map((fieldLabel) => `
            <label class="product-editorial__discounted-measurement-field">
              <span>${escapeHtml(fieldLabel)}</span>
              <input
                type="text"
                placeholder="${escapeHtml(recentlyViewedMeasurementPlaceholder)}"
                data-recent-measurement-field
                disabled
              >
            </label>
          `).join('');
        };

        return `
          <div class="product-editorial__discounted-customize" data-recent-measurement-section>
            <span class="product-editorial__discounted-customize-label">${escapeHtml(recentlyViewedCustomizeLabel)}</span>
            <button type="button" class="product-editorial__discounted-customize-button" data-recent-measurement-toggle aria-expanded="false">
              <span>${escapeHtml(recentlyViewedCustomizeText)}</span>
              <span class="product-editorial__discounted-customize-price">${escapeHtml(recentlyViewedCustomizePrice)}</span>
              <span class="product-editorial__discounted-plus" aria-hidden="true"></span>
            </button>
            <div class="product-editorial__discounted-measurement-body" data-recent-measurement-body hidden>
              <div class="product-editorial__discounted-measurement-grid">
                ${renderMeasurementFields(recentlyViewedMeasurementLeftItems)}
                ${renderMeasurementFields(recentlyViewedMeasurementRightItems)}
              </div>
            </div>
          </div>
        `;
      };

      const readRecentlyViewedProducts = () => {
        try {
          const parsedProducts = JSON.parse(window.localStorage.getItem(recentlyViewedStorageKey) || '[]');
          return Array.isArray(parsedProducts) ? parsedProducts : [];
        } catch (_error) {
          return [];
        }
      };

      const hasVisibleRecentlyViewedPrice = (recentProduct) => {
        const rawPrice = Number(recentProduct?.priceRaw ?? recentProduct?.price_raw);
        if (Number.isFinite(rawPrice)) return rawPrice > 0;

        const productVariants = Array.isArray(recentProduct?.variants) ? recentProduct.variants : [];
        if (productVariants.length) {
          return productVariants.some((variant) => {
            const variantRawPrice = Number(variant?.priceRaw ?? variant?.price_raw ?? variant?.price);
            return Number.isFinite(variantRawPrice) && variantRawPrice > 0;
          });
        }

        const displayPrice = String(recentProduct?.price || '').replace(/[^0-9.]/g, '');
        const numericDisplayPrice = Number(displayPrice);
        return Number.isFinite(numericDisplayPrice) && numericDisplayPrice > 0;
      };

      const writeRecentlyViewedProducts = (products) => {
        try {
          const visibleProducts = products.filter(hasVisibleRecentlyViewedPrice);
          window.localStorage.setItem(recentlyViewedStorageKey, JSON.stringify(visibleProducts.slice(0, 12)));
        } catch (_error) {}
      };

      const getCurrentRecentlyViewedProduct = () => {
        if (!currentRecentlyViewedNode) return null;

        try {
          return JSON.parse(currentRecentlyViewedNode.textContent || '{}');
        } catch (_error) {
          return null;
        }
      };

      const renderRecentlyViewedProducts = async () => {
        if (!recentlyViewedSection || !discountedTrack) return;

        const currentProduct = getCurrentRecentlyViewedProduct();
        const currentProductId = String(currentProduct?.id || '');
        let recentProducts = readRecentlyViewedProducts()
          .filter((recentProduct) => String(recentProduct.id || '') !== currentProductId)
          .filter(hasVisibleRecentlyViewedPrice)
          .slice(0, 8);

        recentProducts = await Promise.all(recentProducts.map(enrichRecentlyViewedProduct));
        recentProducts = recentProducts.filter(hasVisibleRecentlyViewedPrice);

        discountedTrack.innerHTML = recentProducts.map((recentProduct) => `
          <article class="product-editorial__discounted-card" data-discounted-card>
            <div class="product-editorial__discounted-media">
              <a class="product-editorial__discounted-image-link" href="${escapeHtml(recentProduct.url)}">
                ${recentProduct.image
                  ? `<img class="product-editorial__discounted-image" src="${escapeHtml(recentProduct.image)}" alt="${escapeHtml(recentProduct.imageAlt || recentProduct.title)}" loading="lazy" decoding="async">`
                  : '<div class="product-editorial__discounted-image product-editorial__discounted-image--placeholder"></div>'}
              </a>
            </div>
            <div class="product-editorial__discounted-copy">
              <div class="product-editorial__discounted-topline">
                <h3 class="product-editorial__discounted-title">
                  <a href="${escapeHtml(recentProduct.url)}">${escapeHtml(recentProduct.title)}</a>
                </h3>
                <span class="product-editorial__discounted-stock">${recentProduct.available ? 'In-Stock' : 'Sold Out'}</span>
              </div>
              <div class="product-editorial__discounted-price-row">
                <span class="product-editorial__discounted-price">${escapeHtml(formatMoney(recentProduct.priceRaw ?? recentProduct.price_raw ?? 0))}</span>
              </div>
              ${renderRecentlyViewedSizes(recentProduct)}
              ${renderRecentlyViewedCustomize(recentProduct)}
            </div>
          </article>
        `).join('');

        discountedCards = Array.from(discountedTrack.querySelectorAll('[data-discounted-card]'));
        recentlyViewedSection.classList.toggle('is-ready', discountedCards.length > 0);

        discountedCards.forEach((card, index) => {
          const recentProduct = recentProducts[index];
          if (!recentProduct) return;

          const sizeButtons = card.querySelectorAll('[data-recent-size-button]');
          const currentValueNode = card.querySelector('[data-recent-size-current]');
          const priceNode = card.querySelector('.product-editorial__discounted-price');
          const stockNode = card.querySelector('.product-editorial__discounted-stock');
          const measurementSection = card.querySelector('[data-recent-measurement-section]');
          const measurementToggle = card.querySelector('[data-recent-measurement-toggle]');
          const measurementBody = card.querySelector('[data-recent-measurement-body]');
          const measurementFields = card.querySelectorAll('[data-recent-measurement-field]');
          const productVariants = Array.isArray(recentProduct.variants) ? recentProduct.variants : [];
          const sizePosition = Number(recentProduct.sizeOptionPosition || 0);

          if (measurementSection && measurementToggle && measurementBody) {
            measurementToggle.addEventListener('click', () => {
              const isOpen = measurementSection.classList.toggle('is-open');
              measurementToggle.setAttribute('aria-expanded', String(isOpen));
              measurementBody.hidden = !isOpen;

              measurementFields.forEach((field) => {
                field.disabled = !isOpen;
                if (!isOpen) {
                  field.value = '';
                }
              });
            });
          }

          if (!sizeButtons.length || !productVariants.length || !sizePosition) return;

          sizeButtons.forEach((button) => {
            button.addEventListener('click', () => {
              const selectedSize = button.dataset.sizeValue || '';
              recentProduct.selectedSize = selectedSize;

              sizeButtons.forEach((sizeButton) => {
                const isActive = sizeButton === button;
                sizeButton.classList.toggle('is-active', isActive);
                sizeButton.setAttribute('aria-pressed', String(isActive));
              });

              if (currentValueNode) {
                currentValueNode.textContent = selectedSize;
              }

              const matchedVariant = productVariants.find((variant) => String(variant?.options?.[sizePosition - 1] || '') === selectedSize) || null;
              if (matchedVariant) {
                if (priceNode) {
                  priceNode.textContent = matchedVariant.price || recentProduct.price || '';
                }
                if (stockNode) {
                  stockNode.textContent = matchedVariant.available ? 'In-Stock' : 'Sold Out';
                }
              }
            });
          });
        });

        if (currentProduct?.id) {
          const nextProducts = [
            ...(hasVisibleRecentlyViewedPrice(currentProduct) ? [currentProduct] : []),
            ...recentProducts,
            ...readRecentlyViewedProducts().filter((recentProduct) => {
              return String(recentProduct.id || '') !== currentProductId
                && recentProducts.every((recentItem) => String(recentItem.id || '') !== String(recentProduct.id || ''));
            }),
          ];
          writeRecentlyViewedProducts(nextProducts);
        }
      };

      renderRecentlyViewedProducts();

      const discountedVariantCards = section.querySelectorAll('[data-discounted-variant-card]');

      discountedVariantCards.forEach((cardForm) => {
        const variantInputField = cardForm.querySelector('[data-discounted-variant-id]');
        const variantJsonNode = cardForm.querySelector('[data-discounted-variants]');
        const discountedPrice = cardForm.querySelector('[data-discounted-price]');
        const discountedCompare = cardForm.querySelector('[data-discounted-compare]');
        const discountedStock = cardForm.querySelector('[data-discounted-stock]');
        const discountedSubmit = cardForm.querySelector('[data-discounted-submit]');
        const discountedValueNodes = cardForm.querySelectorAll('[data-discounted-current-value]');
        const discountedOptionButtons = cardForm.querySelectorAll('[data-discounted-option-button]');
        const discountedCardImage = cardForm
          .closest('.product-editorial__discounted-card')
          ?.querySelector('.product-editorial__discounted-image-link img');
        const cardMeasurementSection = cardForm.querySelector('[data-discounted-measurement-section]');
        const cardMeasurementToggle = cardForm.querySelector('[data-discounted-measurement-toggle]');
        const cardMeasurementBody = cardForm.querySelector('[data-discounted-measurement-body]');
        const cardMeasurementChoice = cardForm.querySelector('[data-discounted-measurement-choice]');
        const cardMeasurementFeeProperty = cardForm.querySelector('[data-discounted-measurement-fee-property]');
        const cardMeasurementFeeCents = cardForm.querySelector('[data-discounted-measurement-fee-cents]');
        const cardMeasurementFields = cardForm.querySelectorAll('[data-discounted-measurement-field]');

        if (!variantInputField || !variantJsonNode) return;

        let cardVariants = [];
        try {
          cardVariants = JSON.parse(variantJsonNode.textContent);
        } catch (error) {
          console.warn('Discounted card variants JSON could not be parsed.', error);
          return;
        }

        const cardSelectedOptions = {};
        let activeCardVariant = null;

        discountedValueNodes.forEach((valueNode) => {
          cardSelectedOptions[valueNode.dataset.discountedCurrentValue] = valueNode.textContent.trim();
        });

        const findCardVariant = () => {
          return cardVariants.find((variant) => {
            return variant.options.every((optionValue, index) => {
              const selectedValue = cardSelectedOptions[String(index + 1)];
              if (!selectedValue) return true;
              return optionValue === selectedValue;
            });
          }) || null;
        };

        const syncCardValueLabels = () => {
          discountedValueNodes.forEach((valueNode) => {
            const selectedValue = cardSelectedOptions[valueNode.dataset.discountedCurrentValue];
            if (selectedValue) {
              valueNode.textContent = selectedValue;
            }
          });
        };

        const syncCardButtons = () => {
          discountedOptionButtons.forEach((button) => {
            const position = Number(button.dataset.optionPosition);
            const buttonValue = button.dataset.optionValue;
            const isSelected = cardSelectedOptions[String(position)] === buttonValue;
            const hasAvailableVariant = cardVariants.some((variant) => {
              if (!variant.available) return false;

              return variant.options.every((optionValue, index) => {
                const optionPosition = index + 1;
                if (optionPosition === position) {
                  return optionValue === buttonValue;
                }

                const selectedValue = cardSelectedOptions[String(optionPosition)];
                if (!selectedValue) return true;
                return optionValue === selectedValue;
              });
            });

            if (button.classList.contains('product-editorial__discounted-swatch')) {
              button.classList.toggle('is-active', isSelected);
            } else {
              button.classList.toggle('is-active', isSelected);
            }

            button.setAttribute('aria-pressed', String(isSelected));
            button.setAttribute('aria-disabled', String(!hasAvailableVariant));
            button.classList.toggle('is-unavailable', !hasAvailableVariant);
          });
        };

        const isCardMeasurementOpen = () => Boolean(cardMeasurementSection?.classList.contains('is-open'));

        const syncCardMeasurement = () => {
          const isOpen = isCardMeasurementOpen();
          if (cardMeasurementToggle) {
            cardMeasurementToggle.setAttribute('aria-expanded', String(isOpen));
          }
          if (cardMeasurementBody) {
            cardMeasurementBody.hidden = !isOpen;
          }
          if (cardMeasurementChoice) {
            cardMeasurementChoice.disabled = !isOpen;
          }
          if (cardMeasurementFeeProperty) {
            cardMeasurementFeeProperty.disabled = !isOpen;
          }
          if (cardMeasurementFeeCents) {
            cardMeasurementFeeCents.disabled = !isOpen;
          }
          cardMeasurementFields.forEach((field) => {
            field.disabled = !isOpen;
            field.required = isOpen;
            if (!isOpen) {
              field.value = '';
            }
          });
        };

        const syncCardPrice = (variant) => {
          if (!discountedPrice || !variant) return;

          const basePrice = Number(variant.price_raw || 0);
          if (isCardMeasurementOpen() && measurementPriceCents > 0 && basePrice > 0) {
            discountedPrice.textContent = formatMoney(basePrice);
            return;
          }

          discountedPrice.textContent = basePrice > 0 ? formatMoney(basePrice) : variant.price;
        };

        const syncCardAvailability = (variant) => {
          if (discountedStock) {
            const inStockLabel = discountedStock.dataset.inStockLabel || 'In-Stock';
            const soldOutLabel = discountedStock.dataset.soldOutLabel || 'Sold Out';
            discountedStock.textContent = variant && variant.available ? inStockLabel : soldOutLabel;
          }

          if (discountedSubmit) {
            discountedSubmit.disabled = !(variant && variant.available);
          }
        };

        const syncCardVariant = (variant) => {
          if (!variant) return;
          activeCardVariant = variant;

          variantInputField.value = variant.id;

          syncCardPrice(variant);
          syncCardAvailability(variant);

          if (discountedCompare) {
            discountedCompare.textContent = '';
            discountedCompare.style.display = 'none';
          }

          if (discountedCardImage && variant.featured_image_src) {
            discountedCardImage.src = variant.featured_image_src;
            discountedCardImage.alt = variant.featured_image_alt || discountedCardImage.alt;
          }

        };

        discountedOptionButtons.forEach((button) => {
          button.addEventListener('click', () => {
            cardSelectedOptions[button.dataset.optionPosition] = button.dataset.optionValue;
            const matchedVariant = findCardVariant();

            syncCardValueLabels();
            syncCardButtons();

            if (matchedVariant) {
              syncCardVariant(matchedVariant);
            } else {
              syncCardAvailability(null);
            }
          });
        });

        if (cardMeasurementToggle && cardMeasurementSection) {
          cardMeasurementToggle.addEventListener('click', () => {
            cardMeasurementSection.classList.toggle('is-open');
            syncCardMeasurement();
            syncCardPrice(activeCardVariant || findCardVariant());
          });
        }

        syncCardValueLabels();
        syncCardButtons();
        syncCardVariant(findCardVariant() || cardVariants[0] || null);
        syncCardMeasurement();
      });

      if (relatedTrack && relatedCards.length && relatedPrev && relatedNext) {
        let relatedIndex = 0;

        const getCardsPerView = () => {
          if (window.innerWidth <= 640) return 1;
          if (window.innerWidth <= 989) return 2;
          return 4;
        };

        const syncRelatedSlider = () => {
          const cardsPerView = getCardsPerView();
          const maxIndex = Math.max(0, relatedCards.length - cardsPerView);
          relatedIndex = Math.min(relatedIndex, maxIndex);

          const cardWidth = relatedCards[0].getBoundingClientRect().width;
          const trackStyle = window.getComputedStyle(relatedTrack);
          const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || 0);
          const offset = relatedIndex * (cardWidth + gap);

          relatedTrack.style.transform = `translateX(-${offset}px)`;

          const atStart = relatedIndex <= 0;
          const atEnd = relatedIndex >= maxIndex;

          relatedPrev.disabled = atStart;
          relatedPrev.classList.toggle('is-disabled', atStart);
          relatedNext.disabled = atEnd;
          relatedNext.classList.toggle('is-disabled', atEnd);
        };

        relatedPrev.addEventListener('click', () => {
          relatedIndex = Math.max(0, relatedIndex - 1);
          syncRelatedSlider();
        });

        relatedNext.addEventListener('click', () => {
          const cardsPerView = getCardsPerView();
          const maxIndex = Math.max(0, relatedCards.length - cardsPerView);
          relatedIndex = Math.min(maxIndex, relatedIndex + 1);
          syncRelatedSlider();
        });

        window.addEventListener('resize', syncRelatedSlider);
        syncRelatedSlider();
      }

      if (discountedTrack && discountedCards.length && discountedPrev && discountedNext) {
        let discountedIndex = 0;

        const getDiscountedCardsPerView = () => {
          if (window.innerWidth <= 989) return 1;
          return 2;
        };

        const syncDiscountedSlider = () => {
          const cardsPerView = getDiscountedCardsPerView();
          const maxIndex = Math.max(0, discountedCards.length - cardsPerView);
          discountedIndex = Math.min(discountedIndex, maxIndex);

          const cardWidth = discountedCards[0].getBoundingClientRect().width;
          const trackStyle = window.getComputedStyle(discountedTrack);
          const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || 0);
          const offset = discountedIndex * (cardWidth + gap);

          discountedTrack.style.transform = `translateX(-${offset}px)`;

          const atStart = discountedIndex <= 0;
          const atEnd = discountedIndex >= maxIndex;

          if (discountedControls) {
            discountedControls.classList.toggle('is-hidden', maxIndex <= 0);
          }

          discountedPrev.disabled = atStart;
          discountedPrev.classList.toggle('is-disabled', atStart);
          discountedNext.disabled = atEnd;
          discountedNext.classList.toggle('is-disabled', atEnd);
        };

        discountedPrev.addEventListener('click', () => {
          discountedIndex = Math.max(0, discountedIndex - 1);
          syncDiscountedSlider();
        });

        discountedNext.addEventListener('click', () => {
          const cardsPerView = getDiscountedCardsPerView();
          const maxIndex = Math.max(0, discountedCards.length - cardsPerView);
          discountedIndex = Math.min(maxIndex, discountedIndex + 1);
          syncDiscountedSlider();
        });

        window.addEventListener('resize', syncDiscountedSlider);
        syncDiscountedSlider();
      }

      if (craftsmanshipSection && craftsmanshipToggle && craftsmanshipPanel) {
        const syncCraftsmanshipPanel = () => {
          const isOpen = craftsmanshipSection.classList.contains('is-open');
          craftsmanshipToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          craftsmanshipPanel.classList.toggle('is-collapsed', !isOpen);
          craftsmanshipPanel.style.display = isOpen ? 'block' : 'none';
          craftsmanshipPanel.style.maxHeight = isOpen ? 'none' : '0px';
        };

        craftsmanshipToggle.addEventListener('click', () => {
          craftsmanshipSection.classList.toggle('is-open');
          syncCraftsmanshipPanel();
        });

        syncCraftsmanshipPanel();
      }

      if (measurementSection && measurementToggle && measurementBody) {
        const syncMeasurementPanel = () => {
          const isOpen = measurementSection.classList.contains('is-open');
          measurementToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          measurementBody.classList.toggle('is-collapsed', !isOpen);
          measurementBody.style.display = isOpen ? 'block' : 'none';
          measurementBody.style.maxHeight = isOpen ? 'none' : '0px';
        };

        measurementToggle.addEventListener('click', () => {
          measurementSection.classList.toggle('is-open');
          syncMeasurementPanel();
        });

        syncMeasurementPanel();
      }

      if (metaAccordions.length) {
        metaAccordions.forEach((item) => {
          const trigger = item.querySelector('[data-meta-accordion-trigger]');
          const panel = item.querySelector('[data-meta-accordion-panel]');
          if (!trigger || !panel) return;

          const syncPanel = () => {
            const isOpen = item.classList.contains('is-open');
            trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            panel.classList.toggle('is-collapsed', !isOpen);
            panel.style.display = isOpen ? 'block' : 'none';
            panel.style.maxHeight = isOpen ? 'none' : '0px';
          };

          trigger.addEventListener('click', () => {
            item.classList.toggle('is-open');
            syncPanel();
          });

          syncPanel();
        });
      }

      section.dataset.productEditorialInitialized = 'true';
    } catch (error) {
      section.dataset.productEditorialInitialized = 'false';
      console.error('Product section failed to initialize.', error);
    }
  };

  const initAllProductSections = (root) => {
    const scope = root || document;

    if (scope.matches && scope.matches('[id^="ProductSection-"]')) {
      initProductSection(scope);
      return;
    }

    scope.querySelectorAll('[id^="ProductSection-"]').forEach((section) => {
      initProductSection(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllProductSections(document);
    }, { once: true });
  } else {
    initAllProductSections(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllProductSections(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
